export const fieldsUserDescription = {
  last_name: { step: 1, sectionName: 'Личные данные', fieldName: 'Фамилия' },
  first_name: { step: 1, sectionName: 'Личные данные', fieldName: 'Имя' },
  birthday: {
    step: 1,
    sectionName: 'Личные данные',
    fieldName: 'Дата рождения',
  },
  home_latitude: { step: 1, sectionName: 'Личные данные', fieldName: 'Широта дома' },
  home_longitude: { step: 1, sectionName: 'Личные данные', fieldName: 'Долгота дома' },
  phone: { step: 1, sectionName: 'Контакты', fieldName: 'Основной номер' },
  email: { step: 1, sectionName: 'Контакты', fieldName: 'E-mail' },
  partnership_id: {
    step: 1,
    sectionName: 'Место работы',
    fieldName: 'Компания',
  },
  service_function_id: {
    step: 1,
    sectionName: 'Место работы',
    fieldName: 'Служебная функция',
  },
  emp_number: {
    step: 1,
    sectionName: 'Место работы',
    fieldName: 'Табельный номер ВК',
  },
  qualification_coefficient: {
    step: 1,
    sectionName: 'Место работы',
    fieldName: 'Коэффициент сотрудника',
  },
  personnel_number: {
    step: 1,
    sectionName: 'Место работы',
    fieldName: 'Табельный номер подрядчика',
  },
  role: {
    step: 2,
    sectionName: 'Роли',
    fieldName: 'Доступные сотруднику роли',
  },
  default_group_id: {
    step: 2,
    sectionName: 'Роли',
    fieldName: 'Основная роль',
  },
  employee_type: {
    step: 3,
    sectionName: 'Дополнительные данные',
    fieldName: 'Тип сотрудника',
  },
  status: {
    step: 3,
    sectionName: 'Дополнительные данные',
    fieldName: 'Текущий статус',
  },
  hire_date: {
    step: 3,
    sectionName: 'Дополнительные данные',
    fieldName: 'Дата приема на работу',
  },
  dismissal_date: {
    step: 3,
    sectionName: 'Дополнительные данные',
    fieldName: 'Дата увольнения',
  },
  dismissal_reason: {
    step: 3,
    sectionName: 'Дополнительные данные',
    fieldName: 'Причина увольнения',
  },
};
